<template>
  <div
    class="grid grid-cols-12 clamp-gap-4-4"
    :class="{
      'clamp-gap-y-8-8': component === 'ModuleCards',
    }">
    <div
      v-for="card in cards"
      :key="card._uid"
      class="effect-hover-tilt-parent col-span-6"
      :class="{
        'tp:col-span-6': layout === 'grid-2',
        'tp:col-span-4': layout === 'grid-3',
        'tp:col-span-3': layout === 'grid-4',
      }">
      <SbElementSpotlightGridCard
        v-if="card.component === 'ElementSpotlightCard'"
        :blok="card"
        :tintOpacity="tintOpacity"
        :sizes="[
          { vw: 100 / cols, bpMin: 'tp' },
          { vw: 50, bpMin: '0' },
        ]" />
      <SbElementCardsCard
        v-else
        :blok="card"
        :roundedMedia="roundedMedia"
        :sizes="[
          { vw: 100 / cols, bpMin: 'tp' },
          { vw: 50, bpMin: '0' },
        ]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ElementCardsCardStoryblok,
  ElementSpotlightCardStoryblok,
  ModuleCardsStoryblok,
  ModuleSpotlightStoryblok,
} from "@/types";

interface Props {
  component:
    | ModuleSpotlightStoryblok["component"]
    | ModuleCardsStoryblok["component"];
  layout: ModuleSpotlightStoryblok["layout"] | ModuleCardsStoryblok["layout"];
  cards: ElementSpotlightCardStoryblok[] | ElementCardsCardStoryblok[];
  tintOpacity?: number;
  roundedMedia?: boolean;
}
const props = defineProps<Props>();

const cols = computed(() => {
  switch (props.layout) {
    case "grid-2":
      return 2;
    case "grid-3":
      return 3;
    case "grid-4":
      return 4;
    default:
      return 1;
  }
});
</script>

<style scoped></style>
